import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Heart } from "lucide-react";

const StandUpDzienKobiet = () => (
  <SeoPageLayout title="Stand-up na" titleAccent="Dzień Kobiet">
    <SeoSection title="Występ komediowy na Dzień Kobiet w firmie">
      <p>Dzień Kobiet w firmie to doskonała okazja, aby docenić pracowniczki i stworzyć wyjątkową atmosferę świętowania. Zamiast tradycyjnych kwiatów i czekoladek - podaruj paniom niezapomniany występ komediowy! Profesjonalny stand-up na Dzień Kobiet to elegancka, zabawna i oryginalna forma uczczenia tego święta, która rozbawi całą firmę i pokaże, że doceniasz swój zespół.</p>
    </SeoSection>

    <SeoSection title="Jak wygląda występ na Dzień Kobiet?">
      <SeoStyledList items={[
        "Humorystyczne obserwacje o relacjach damsko-męskich w pracy",
        "Spersonalizowane żarty nawiązujące do firmy i zespołu",
        "Interaktywne elementy z udziałem publiczności",
        "Elegancki humor dopasowany do okazji",
        "Możliwość połączenia z innymi atrakcjami - catering, kwiaty, upominki",
        "Format od krótkiego 15-minutowego seta po pełny 45-minutowy show"
      ]} />
    </SeoSection>

    <SeoSection title="Formaty na Dzień Kobiet">
      <p>Oferujemy różne formaty występów na Dzień Kobiet - od kameralnego stand-upu w sali konferencyjnej, przez eleganckie show podczas lunchu firmowego, po pełnowymiarowy wieczór komediowy z kolacją. Nasi komicy potrafią dopasować materiał zarówno do kameralnych zespołów, jak i dużych organizacji z setkami pracowników.</p>
    </SeoSection>

    <SeoSection title="Zamów komika na Dzień Kobiet">
      <p>Zaskocz swój zespół oryginalnym prezentem na 8 marca! Skontaktuj się z nami z wyprzedzeniem - terminy wokół Dnia Kobiet cieszą się dużym zainteresowaniem. Zaproponujemy format, który idealnie pasuje do charakteru Twojej firmy.</p>
      <SeoHighlightBox icon={Heart}>
        Daj pracowniczkom coś lepszego niż kwiaty - podaruj im wspólny śmiech, który zapamiętają na długo!
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default StandUpDzienKobiet;
